<template>
  <div :class="[$style['address-css'] ,$style['basket']]">
    <div :class="$style['itemsBasket']">
      <div :class="$style['contentBasket']">
        <div
            v-if="userProfile != null && (userProfile.user_addresses == null || userProfile.user_addresses.length == 0)"
            style="margin-top: 80%">
          <div :class="$style['contentTransaction']">
            <v-icon>search_off</v-icon>
            <span>آدرسی ثبت نشده است</span>
          </div>
        </div>
        <div v-if="userProfile != null && userProfile.user_addresses != null && userProfile.user_addresses.length > 0"
             :class="$style['address-box']" style="margin: 0 10px 0 10px">
          <div v-for="(item, index) in userProfile.user_addresses"
               :key="index">
            <div style="display: flex;">
              <v-icon
                  role="button" v-ripple @click="editItem(item, index)"
                  style="color: #7dc353;  margin-left: 10px;">create
              </v-icon>
              <div style="flex: 1; height: auto; margin: 10px 0;">
                <h4>
                  {{ item.address_title }}
                </h4>
                <h5 style="font-size: 13px; color: #9a9696; font-weight: normal">
                  {{ item.address_description }}
                </h5>
              </div>
              <v-icon role="button" v-ripple @click="removeItem(item)">remove</v-icon>
            </div>
            <div style="height: 1px; background: #b7b7b7; width: 90%"></div>
          </div>
        </div>
        <div :class="$style['btn_registration']">
          <v-btn block color="#7ec352" large role="button" v-ripple @click="editMode = false, showModal = true"
          >افزودن آدرس
          </v-btn>
        </div>
      </div>
    </div>

    <div id="mapOrder" :class="[$style['MainMapCss'] ,$style['scrollTop']]" v-if="CheckDisable">
      <mapir
          @click="hv"
          :center="center"
          :apiKey="apiKey"
          :class="$style['MainMapCss_Sub']">
        <mapAttributionControl/>
        <mapNavigationControl position="top-right"/>
        <mapGeolocateControl position="top-left"/>
        <mapScaleControl position="top-left"/>
        <mapMarker
            ref="markerr"
            :coordinates.sync="markerCoordinates"
            color="red"
            icon=""
            @click="markerOnClick"
            :draggable="true"
            @dragend="getlatLng">
          <img src="https://api.cluna.app/file/download/png/1641123030729-w1c4gu2hk7.png" alt="" slot="marker"
               :class="$style['mapMarker']"
               style="width: 9%"/>
          <mapPopup>
            <div>انتخاب آدرس</div>
          </mapPopup>
        </mapMarker>
        <div style="width: 100%;display: flex;justify-content: center;">
          <v-btn role="button" v-ripple @click="something" color="#679e44"
                 style="width: 30%; margin: 0;margin-bottom: 10px; position: fixed;bottom: 0; color: white; border-radius: 25px"
                 large>
            ثبت ادرس
          </v-btn>
          <v-btn color="#ff0000" role="button" v-ripple @click="CheckDisable = false"
                 style="width: 20%; margin: 0; margin-bottom: 10px; position: fixed;bottom: 0;left: 10px; color: white; border-radius: 25px"
                 large>
            انصراف
          </v-btn>
        </div>
      </mapir>
    </div>
    <v-dialog v-model="showModal" transition="scroll-y-transition">
      <v-card :class="[$style['box-modal'], $style['address-css']]">
        <div style="text-align: left" role="button" v-ripple @click="showModal = false">
          <v-icon style="font-size: 28px;font-weight: bold;padding: 5px 5px;">clear
          </v-icon>
        </div>
        <v-text-field
            :class="$style.textfield"
            style="background-color: white;"
            label="عنوان آدرس انتخابی"
            v-model="address_title">
        </v-text-field>
        <v-textarea
            :class="$style.textfield"
            style="background-color: white;"
            label="آدرس دقیق پستی خود را وارد نمائید"
            v-model="address_description">
        </v-textarea>
        <span style="font-size: 11px; margin-left: 15px; margin-right: 15px; color: #9a9696; margin-bottom: 5px">انتخاب موقعیت جغرافیایی</span>
        <div
            style="display: flex; flex-wrap: wrap; justify-content: center;margin-right: 15px;margin-left: 15px;"
            :class="$style['CssBtnMap']">
          <v-btn
              role="button" v-ripple @click="CheckDisable = true"
              style="width: 100%; background-color: #7dc353; color: white;
                             text-align: right; display: flex;">
            <v-icon>person_pin_circle</v-icon>
            انتخاب آدرس از روی نقشه
          </v-btn>
        </div>
        <v-btn
            style="width: 100%; background-color: #7dc353; color: white;
                     padding: 0!important; margin: 20px 0 0 0 !important;"
            role="button" v-ripple @click="SetMap">
          ثبت
        </v-btn>
      </v-card>
    </v-dialog>

    <v-snackbar
        v-model="snackbar"
        top
        :color="snackbar_color"
        timeout="6000">
      {{ snackbar_text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" role="button" v-ripple @click="snackbar = false">
          <v-icon>cancel</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import oracle from "@/utils/oracle";
import {
  mapir,
  mapMarker,
  mapAttributionControl,
  mapNavigationControl,
  mapGeolocateControl,
  mapScaleControl,
  mapPopup,
} from "mapir-vue";

export default {
  name: "Address",
  components: {
    mapir,
    mapNavigationControl,
    mapMarker,
    mapAttributionControl,
    mapGeolocateControl,
    mapScaleControl,
    mapPopup,
  },
  data: () => ({
    snackbar_color: null,
    snackbar_text: null,
    snackbar: false,
    CheckDisable: false,
    center: [51.420296, 35.732379],
    apiKey: "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIn0.eyJhdWQiOiIxMjg0MyIsImp0aSI6Ijc3OTZjOTI0MGJlNzA2ODFhZjkwOGZmNjJkMmNmZDZjZGEyZGZiYjg5ZTk1YzYwYmI5ODFkZDA1ZGM4YWUzMDdlZmE1YmEwMGEwMDUyNTcxIiwiaWF0IjoxNjEzNTYxNDIwLCJuYmYiOjE2MTM1NjE0MjAsImV4cCI6MTYxNjA2NzAyMCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.PGE1y2V5xX6kKL5qG08k21qZ5fzge8RD_DaBkMuQW7vOdHFzwnM1rGnuiCQ9dPw7irbURXkNT5SdLRWGAjDzahK4dH6Y4QT3DScuEm05ZSozzgWaBMNDdQmBF8-Hi01StkZqBP4wrZMLO1PpxgEe9zjbZRSY_yfFr4usUuSyYeYxT3DPo4GrDz7WFWzpl73mKl30ka_THDdPj0d3f_cnwAOsZuETS3hzeb_duplYGIbwJAFZ4OsTlVKYnxPp8lHyboa3rwP0I3inQB2o-lzZFJjsEGZYhVKZeayUR_3t4DthI52NJvJDvTYb-yAs5zXcm6vWDnWEc0Kd9pp45qPcAQ",
    markerCoordinates: [51.420296, 35.732379],
    showModal: false,
    address_description: '',
    address_title: '',
    oracle: oracle,
    userProfile: null,
    editMode: false,
    editIndex: 0
  }),
  methods: {
    editItem(item, index) {
      this.showModal = true;
      this.editMode = true
      this.editIndex = index
      this.address_title = item.address_title;
      this.address_description = item.address_description;
      this.markerCoordinates[1] = item.address_lat;
      this.markerCoordinates[0] = item.address_lng;
    },
    removeItem(item) {
      let Address = [];
      for (let i = 0; i < this.userProfile.user_addresses.length; i++) {
        if (item != this.userProfile.user_addresses[i]) {
          Address.push(this.userProfile.user_addresses[i]);
        }
      }
      oracle.axios("user/edit", {user_addresses: Address}, this.FinalSetMap);
    },
    hv(data) {
      this.markerCoordinates[1] = data.actualEvent.lngLat.lat;
      this.markerCoordinates[0] = data.actualEvent.lngLat.lng;
      this.$refs.markerr.$data.marker.setLngLat({
        lng: this.markerCoordinates[0],
        lat: this.markerCoordinates[1],
      });
    },
    markerOnClick(e) {
    },
    getlatLng(params) {
      this.lat = params.marker._lngLat.lat;
      this.lng = params.marker._lngLat.lng;
    },
    something() {
      this.CheckDisable = false
      this.snackbar_text = "موقعیت جغرافیایی تنظیم شد"
      this.snackbar_color = "success"
      this.snackbar = true;
    },
    SetMap() {
      if ((this.markerCoordinates[1] == this.center[1] && this.markerCoordinates[0] == this.center[0])
          || this.address_title == null || this.address_title.trim().length == 0
          || this.address_description == null || this.address_description.trim().length == 0
      ) {
        this.snackbar_text = "لطفا اطلاعات لازم را با دقت تکمیل نمایید"
        this.snackbar_color = "error"
        this.snackbar = true;
        return
      }
      let data = {
        address_description: this.address_description,
        address_title: this.address_title,
        address_lat: this.markerCoordinates[1],
        address_lng: this.markerCoordinates[0],
      }
      let array
      if (!this.editMode) {
        if (
            this.userProfile.user_addresses &&
            this.userProfile.user_addresses.length > 0
        ) {
          array = this.userProfile.user_addresses;
          array.push(data);
        } else {
          array = [data];
        }
      } else {
        array = this.userProfile.user_addresses
        array[this.editIndex] = data
      }
      oracle.axios(
          "user/edit",
          {user_addresses: array},
          this.FinalSetMap
      );
    },
    FinalSetMap() {
      this.CheckDisable = false;
      this.showModal = false;
      this.fetchData()
    },
    fetchData() {
      oracle.axios("user/getProfile", {}, (res) => {
        this.userProfile = res.data;
      });
    },
  },
  mounted() {
    this.fetchData()
  },
};
</script>
<style module>
.address-css .MainMapCss_Sub {
  height: calc(100% - 56px) !important;
  margin-top: 56px;
  display: flex;
  position: absolute;
  z-index: 30000;
  width: 100%;
  top: 0;
  left: 0;
}

.address-css {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: #fff;
}

.address-css .footerBasket {
  box-shadow: 0 0 3px -1px #707070;
  background: #fff;
}

.address-css .header-basket {
  background: #e1e3e5;
  padding: 15px 10px;
}

.address-css .header-basket h2 {
  font-size: 12px;
  color: #000;
  font-weight: 100;
  text-align: justify;
}

.address-css .btn_registration {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
}

.address-css .btn_registration button {
  height: 60px !important;
  border-radius: 0;
  font-size: 15px;
  color: #fff !important;
}

.address-css .amountBasket {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  padding: 15px;
}

.address-css .btnaddAddress button {
  margin: 0 auto;
  display: flex;
  width: 100%;
}

.address-css .imageBasket {
  width: 100px;
  height: 100px;
  object-fit: contain;
  /*display: flex;*/
}

.address-css .imageBasket-top {
  display: flex;
  align-items: center;
}

.address-css .imageBasket-top span {
  font-size: 10px;
}

.address-css .imageBasket img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
}

.address-css .img-basket img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.address-css .textproductBasket span:nth-child(3),
.address-css .amountBasket span:last-child {
  color: #7ec352 !important;
}

.address-css .productBasket {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.address-css .addproductBasket ul {
  display: flex;
}

.address-css .addproductBasket ul li {
  padding: 0 5px;
}

.address-css .textfield {
  margin-right: 15px;
  margin-left: 15px;
}

.address-css .textfield input, .address-css .textfield textarea {
  font-size: 15px !important;
  text-align: right;
}


.address-css .textfield label {
  font-size: 12px !important;
}

.address-css .contentBasket {
  padding: 15px 10px;
}

.address-css .closetBasket .v-icon {
  color: #cccccc;
}

.address-css .itemsBasket {
  height: 80%;
  overflow: auto;
}

.address-css .btnaddAddress .v-icon {
  padding-left: 5px;
}

.address-css .btnaddAddress a {
  text-decoration: none;
}

.address-css .box-modal {
  padding: 10px 15px;
}

.address-css .box-modal input::placeholder {
  font-size: 12px;
}

.address-css .headline-tv {
  display: flex;
  justify-content: space-between;
  padding: 10px;
}

.address-css .headline-tv span {
  font-size: 12px !important;
  font-weight: bold;
}

.address-css .backpages,
.address-css .backpages .v-icon {
  color: #cad5d1;
  display: flex;
  align-items: center;
  font-weight: 100;
}

.address-css .backpages .v-icon {
  font-size: 20px !important;
}

.address-css .backpages span {
  font-weight: 100;
}

.address-css .btnAddprice button {
  margin: 15px 0;
  background: #26c6da !important;
  color: #fff !important;
  width: 100%;
  height: 60px;
}

.address-css .btnAddprice button {
  margin-bottom: 0;
}

.address-css .btn-accept {
  width: 80%;
}

.address-css .contentTransaction i {
  color: #7ec352;
  font-size: 5em;
  margin: 0 auto;
}

.address-css .contentTransaction span {
  font-size: 13px;
}

.address-css .contentTransaction {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.address-css .contentTransaction .v-icon {
  font-size: 4em;
}

.address-css .contentTransaction span {
  font-size: 12px;
}
</style>
